module.exports = __webpack_public_path__ + "static/undraw_Integration-8783caf13cbc45d6012c51aff18fb683.svg";